<template>
	<div class="createParks">
		<div class="main-filter">
			<el-form inline :model="queryData" class="demo-form-inline search-form">
				<el-form-item label="用户名称：">
					<el-autocomplete
						v-model.trim="formInline.userName"
						:fetch-suggestions="querySearchAsync"
						clearable
						placeholder="请输入内容"
					></el-autocomplete>
				</el-form-item>
				<el-form-item label="处理状态">
					<el-select v-model="formInline.state">
						<el-option label="全部" value=""></el-option>
						<el-option label="同意" value="U"></el-option>
						<el-option label="不同意" value="R"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSearch" icon="el-icon-search">搜索</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="main-content">
			<div class="main-content-title">
				<p>共有 {{ total }} 条结果</p>
			</div>
			<Table
				:loading="loading"
				:table-data="tableData"
				:total="total"
				:table-head="tableHead"
				:current-page.sync="queryData.current"
				:page-size.sync="queryData.size"
				:is-show-selection="false"
				:operation-column-width="220"
				:showOperation="true"
				@change-page="getList"
				:tableHeight="tableHeight"
			>
				<template #enabled="{ scope }">
					<el-switch
						inactive-text="否"
						active-text="是"
						v-model="scope.row.enabled"
						@change="changeOpen(scope.row)"
						:disabled="scope.row.state == 'O'"
					>
					</el-switch>
				</template>
				<template #healthServiceGroup="{ scope }">
					<el-button @click="showList(scope.row)" type="text">
						{{ scope.row.healthServiceGroup && scope.row.healthServiceGroup.title }}({{
							scope.row.healthServiceGroupingList && scope.row.healthServiceGroupingList.length
						}})
					</el-button>
				</template>
				<!-- 插槽操作栏固定属性operation -->
				<template #operation="{ scope }">
					<el-button @click="modifyParkInfo(true, scope.row)" size="mini" type="primary"> 查看 </el-button>
					<el-button @click="modifyParkInfo(false, scope.row)" size="mini" type="warning" :disabled="scope.row.state == 'O' || scope.row.enabled">
						处理
					</el-button>
					<el-button @click="stopService(scope.row)" size="mini" type="danger" :disabled="scope.row.state == 'O'"> 结束服务 </el-button>
				</template>
			</Table>
		</div>
		<createView @getList="getList" ref="createView" :isShowDetail="isShowDetail" />
		<ShowList ref="showList"></ShowList>
	</div>
</template>

<script>
export default {
	name: 'doctorService',
	components: {
		Table: () => import('@/components/Table/table'),
		createView: () => import('./newDialog.vue'),
		ShowList: () => import('./showList.vue'),
	},
	data() {
		return {
			loading: false,
			checkRow: {},
			formInline: {
				userName: '',
				state: '',
			},
			queryData: {
				current: 1,
				size: 10,
			},
			total: 0,
			options: [],
			tableData: [],
			tableHead: [
				{
					label: '请求编号',
					prop: 'applicationNumber',
					formatter: (row) => {
						return row.applicationNumber || '-';
					},
				},
				{
					label: '请求用户',
					prop: 'creator',
					formatter: (row) => {
						return row.creator?.title || '-';
					},
				},
				{
					label: '联系电话',
					prop: 'creator',
					formatter: (row) => {
						return row.creator?.code || '-';
					},
				},
				{
					label: '家庭成员信息',
					prop: 'householdMemberList',
					formatter: (row) => {
						return row.householdMemberList?.map((v) => v.title).toString() || '-';
					},
				},
				{
					label: '要求卫生服务团队',
					prop: 'healthServiceGroup',
				},
				{
					label: '请求时间',
					prop: 'createTime',
				},
				{
					label: '处理状态',
					prop: 'state',
					formatter: (row) => {
						return row.state == 'P'
							? '申请中'
							: row.state == 'U'
							? '待支付'
							: row.state == 'A'
							? '生效中'
							: row.state == 'O'
							? '已过期'
							: row.state == 'R'
							? '拒绝'
							: '-';
					},
				},
				{
					label: '是否启用',
					prop: 'enabled',
					width: 110,
				},
			],
			filterLoading: false,
			isShowDetail: false,
		};
	},
	computed: {
		tableHeight() {
			return window.innerHeight - 300;
		},
	},
	mounted() {
		this.getList();
	},
	methods: {
		// 搜索建议
		querySearchAsync(queryString, cb) {
			queryString ? this.getList('filter') : '';
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				cb(this.options);
			}, 1000 * Math.random());
		},
		onSearch(data) {
			this.queryData.current = 1;
			this.getList('', data);
		},
		//获取列表
		getList(type = '') {
			type == 'filter' ? '' : (this.loading = true);
			let data = {
				...this.queryData,
				...this.formInline,
			};
			this.$http
				.get(this.api['HealthServiceApplications#index'].href, { params: data })
				.then((res) => {
					if (res.data && res.data.success) {
						if (type == 'filter') {
							this.filterLoading = false;
							this.options = res.data.collection.map((item) => {
								return {
									...item,
									value: item.creator?.title,
								};
							});
						} else {
							this.tableData = res.data.collection || [];
							this.total = res.data.pagination.totalItems || 0;
							this.loading = false;
						}
					}
				})
				.catch((e) => {
					this.loading = false;
				});
		},
		modifyParkInfo(isShowDetail, row) {
			this.$refs.createView.init(row);
			this.$refs.createView.link = row._links.update.href;
			this.isShowDetail = isShowDetail;
		},
		changeOpen(row) {
			this.$http
				.put(row._links.update.href, row)
				.then((res) => {
					if (res.data && res.data.success) {
						this.$message.success('操作成功');
						this.getList();
					}
				})
				.catch((e) => {});
		},
		stopService(row) {
			let data = {
				id: row.id,
				state: 'O',
			};
			this.$http
				.put(row._links.update.href, data)
				.then((res) => {
					if (res.data && res.data.success) {
						this.$message.success('操作成功');
						this.getList();
					}
				})
				.catch((e) => {});
		},
		showList(row) {
			if (!row.healthServiceGroupingList || row.healthServiceGroupingList.length == 0) return;
			this.$refs.showList.showVisible = true;
			this.$refs.showList.tableData = row.healthServiceGroupingList || [];
		},
	},
};
</script>

<style lang="scss" scoped>
/deep/ .search-form {
	.el-select {
		width: 120px;
		.el-input {
			width: 120px;
			.el-input__inner {
				width: 120px;
			}
		}
	}
	.el-input {
		width: 160px;
	}
}
.main-content {
	&-title {
		line-height: 48px;
		display: flex;
		justify-content: space-between;
		.el-button {
			line-height: 32px;
			padding: 0 16px;
			height: 32px;
			margin-top: 8px;
		}
	}
}
.seeMore {
	color: #1db9b1;
}
</style>
